import React, { useMemo } from 'react';
import MainTitle from './main_title';

const ChurnCompleted: React.FC = () => {
  const styles = useMemo(() => getStyles(), []);

  return (
    <div style={styles.container}>
      <div style={styles.inner}>
        <MainTitle value="解約完了" />
        <div style={styles.card}>
          <p>AI EXPENSEの解約処理が完了いたしました。</p>
          <p>
            ご登録のメールアドレス宛に解約完了のメッセージをお送りしておりますので
            <br />
            合わせてご確認をお願いします。
          </p>
        </div>
      </div>
    </div>
  );
};

const getStyles = () => ({
  container: {
    padding: '30px 24px 0'
  },
  inner: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  card: {
    background: 'white',
    borderRadius: '4px',
    padding: '28px 32px',
    marginTop: '12px',
    fontSize: '1.1rem'
  }
});

export default ChurnCompleted;
